var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchiveBlueIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83366 5.50002H17.167M3.83366 5.50002V12.4334C3.83366 14.6736 3.83366 15.7937 4.26963 16.6493C4.65313 17.402 5.26505 18.0139 6.0177 18.3974C6.87334 18.8334 7.99345 18.8334 10.2337 18.8334H10.767C13.0072 18.8334 14.1273 18.8334 14.983 18.3974C15.7356 18.0139 16.3475 17.402 16.731 16.6493C17.167 15.7937 17.167 14.6736 17.167 12.4334V5.50002M3.83366 5.50002C2.91318 5.50002 2.16699 4.75383 2.16699 3.83335C2.16699 2.91288 2.91318 2.16669 3.83366 2.16669H17.167C18.0875 2.16669 18.8337 2.91288 18.8337 3.83335C18.8337 4.75383 18.0875 5.50002 17.167 5.50002M8.00033 8.83335H13.0003",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchiveBlueIcon);
export default ForwardRef;